export class ServiceOrder {
    name!: boolean;
    professional!: boolean;
    specialty!: boolean;
    value!: boolean;
    transferValue!: boolean;
    percentValue!: boolean;
}


